import API from "utils/API";
import authHeader from "utils/auth-header";
import { IIncident } from "../domain/IIncident";
import { IIncidentType } from "../domain/IIncidentType";
import { IIncidentUpdate } from "../domain/IIncidentUpdate";
import { IIncidentCreate } from "../domain/IIncidnetCreate";
import { IResponseIncidents } from "../domain/IResponseIncidents";
import { IResponseIncidentTypes } from "../domain/IResponseIncidentTypes";
import { IIncidentSearch } from "../domain/IIncidentSearch";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IMessage } from "domain/IMessage";

const getAllIncidentTypes = async (): Promise<IIncidentType[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseIncidentTypes>(
      "/incidents/protected/incident-type",
      { headers }
    );
    let incidentTypes = response.data.incidentTypes;
    return incidentTypes;
  } catch (err) {
    throw err;
  }
};

const createIncidentType = async (name: string): Promise<IIncidentType> => {
  var headers = authHeader();
  try {
    const response = await API.post<IIncidentType>(
      "/incidents/protected/incident-type",
      { name },
      { headers }
    );
    let incidentType = response.data;
    return incidentType;
  } catch (err) {
    throw err;
  }
};

const updateIncidentForWorkingEmployee = async (
  data: IIncidentUpdate
): Promise<IIncident> => {
  var headers = authHeader();
  const { incidentId, ...rest } = data;
  try {
    const response = await API.put<IIncident>(
      `/incidents/protected/incident/${incidentId}`,
      rest,
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const getAllIncidentsInPeriodForEmployee = async (
  search: IIncidentSearch | undefined
): Promise<IResponseIncidents> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseIncidents>(
      `/incidents/protected/incident${getQeuryParams(search)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createIncidentForWorkingEmployee = async (
  data: IIncidentCreate
): Promise<IIncident> => {
  var headers = authHeader();
  try {
    console.log(data);
    const response = await API.post<IIncident>(
      "/incidents/protected/incident",
      data,
      { headers }
    );

    let incident = response.data;
    return incident;
  } catch (err) {
    throw err;
  }
};

const deleteIncident = async (incidentId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/incidents/protected/incident/${incidentId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
}

export const incidentsService = {
  updateIncidentForWorkingEmployee,
  getAllIncidentsInPeriodForEmployee,
  createIncidentForWorkingEmployee,
  getAllIncidentTypes,
  createIncidentType,
  deleteIncident,
};
